import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import useFirestore from "../../../../config/fireBaseHook";

const AdminUsersDropdown = ({
  value,
  onChange,
  name = "Project_Manager_Name",
  label = "Pathway Manager Name",
  fullWidth = true,
  margin = "normal",
  required = false,
  disabled = false,
  ...otherProps
}) => {
  const { data: users, loading, error } = useFirestore("users");

  // Filter for admin users
  const adminUsers = users
    ?.filter(
      (user) =>
        user.techPrepAdminFlag === true || user.userTypes?.admin === true,
    )
    ?.sort((a, b) => (a.name || "").localeCompare(b.name || ""));

  const handleChange = (event) => {
    if (onChange) {
      // Create a synthetic event-like object to match the expected format
      const syntheticEvent = {
        target: {
          name: name,
          value: event.target.value,
        },
      };
      onChange(syntheticEvent);
    }
  };

  // Check if current value exists in admin users
  const currentValueExists = adminUsers?.some((user) => user.name === value);

  if (loading) {
    return (
      <FormControl fullWidth={fullWidth} margin={margin} disabled>
        <InputLabel>{label}</InputLabel>
        <Select value="" label={label} disabled {...otherProps}>
          <MenuItem value="">
            <CircularProgress size={20} />
            <span style={{ marginLeft: 8 }}>Loading...</span>
          </MenuItem>
        </Select>
      </FormControl>
    );
  }

  if (error) {
    return (
      <FormControl fullWidth={fullWidth} margin={margin} disabled>
        <InputLabel error>{label}</InputLabel>
        <Select value="" label={label} error disabled {...otherProps}>
          <MenuItem value="">
            <span style={{ color: "red" }}>Error loading admin users</span>
          </MenuItem>
        </Select>
      </FormControl>
    );
  }

  return (
    <FormControl
      fullWidth={fullWidth}
      margin="none"
      variant="outlined"
      required={required}
      disabled={disabled}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        value={value || ""}
        onChange={handleChange}
        label={label}
        name={name}
        {...otherProps}
      >
        <MenuItem value="">
          <em>Select {label}</em>
        </MenuItem>
        {value && !currentValueExists && (
          <MenuItem
            value={value}
            style={{ fontStyle: "italic", color: "#999" }}
          >
            {value} (Current value - not in list)
          </MenuItem>
        )}
        {adminUsers?.map((user) => (
          <MenuItem key={user.id} value={user.name}>
            {user.name} ({user.email})
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AdminUsersDropdown;
